import React, { useEffect, useState } from 'react'
import '../styles/Admins.css'
import LiquidBlock from '../Blocks/LiquidBlock'
import API from '../APIs/AdminApi'
import LiquidSelector from '../Blocks/LiquidSelector'
import LiquidRoundButton from '../Blocks/LiquidRoundButton'
import ToggleSwitch from '../Blocks/ToggleSwitch'

import editAdminIcon from '../imgs/user-pen.svg'
import deleteAdminIcon from '../imgs/trash.svg'
import saveIcon from '../imgs/disk.svg'
import cancelIcon from '../imgs/cross-small.svg'
import LiquidButton from '../Blocks/LiquidButton'

const Admins = ({adminData}) => {
  const [admins, setAdmins] = useState([])
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [isCreateNew, setIsCreateNew] = useState(false)

  const [isEditing, setIsEditing] = useState(false);
  const [editAdmin, setEditAdmin] = useState(null);

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [adminToDelete, setAdminToDelete] = useState(null);
  
  // Состояние для нового администратора
  const [newAdmin, setNewAdmin] = useState({
  firstName: '',
  secondName: '',
  thirdName: '',
  birthDate: '',
  login: '',
  password: '',
  confirmPassword: '',
  mobile: '',
  role: adminData?.role || 4, // По умолчанию роль текущего админа
  canViewAdmins: false,
  canAddAdmins: false,
  canEditAdmins: false,
  canDeleteAdmins: false,
  canCreateEvent: false,
  canEditEvent: false,
  canChangeEventStatus: false,
  canDeleteMembers: false,
  canViewUsers: false,
  canDeleteUsers: false,
  canScanQR: false
});

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formatAdminName = (admin) => {
    if (!admin) return '';
    
    const firstName = admin.firstName || '';
    const secondName = admin.secondName ? `${admin.secondName.charAt(0)}.` : '';
    const thirdName = admin.thirdName ? `${admin.thirdName.charAt(0)}.` : '';
    
    return `${firstName} ${secondName}${thirdName}`.trim();
  };

  const getAdminId = (admin) => admin?._id;

  const handleAdminSelect = (admin) => {
    setIsCreateNew(false);
    setIsEditing(false);
    setEditAdmin(null);
    setSelectedAdmin(admin);
    console.log('Выбран администратор:', admin);
  };

  // Обработчики для формы нового администратора
  const handleInputChange = (field, value) => {
  setNewAdmin(prev => {
    const updatedAdmin = {
      ...prev,
      [field]: value
    };
    
    // Логируем изменения для отладки (можно удалить после фикса)
    console.log(`Field ${field} changed to:`, value);
    console.log('Current state:', updatedAdmin);
    
    return updatedAdmin;
  });
  
  // Очищаем ошибку при изменении поля
  if (errors[field]) {
    setErrors(prev => ({
      ...prev,
      [field]: ''
    }));
  }
};

  const handlePermissionChange = (permission, value) => {
    setNewAdmin(prev => ({
      ...prev,
      [permission]: value
    }));

    // Если выдается право на управление админами, автоматически повышаем роль
    if (['canAddAdmins', 'canEditAdmins', 'canDeleteAdmins'].includes(permission) && value) {
      const minRoleForAdminManagement = 2; // Минимальная роль для управления админами
      if (newAdmin.role > minRoleForAdminManagement) {
        setNewAdmin(prev => ({
          ...prev,
          role: minRoleForAdminManagement
        }));
      }
    }
  };

  const getAvailableRoles = () => {
    const currentAdminRole = adminData?.role || 4;
    
    // Явно возвращаем массив
    const roles = [
      { value: 1, label: '1 (Наивысший)' },
      { value: 2, label: '2 (Высокий)' },
      { value: 3, label: '3 (Средний)' },
      { value: 4, label: '4 (Низкий)' }
    ];
    
    // Фильтруем роли, оставляя только те, что >= роли текущего админа
    const filteredRoles = roles.filter(role => role.value >= currentAdminRole);
    
    // Гарантируем, что возвращается массив
    return Array.isArray(filteredRoles) ? filteredRoles : [];
  };

  // Валидация формы
  const validateForm = () => {
    const newErrors = {};
    const currentAdminRole = adminData?.role || 4;

    if (newAdmin.role < currentAdminRole) {
      newErrors.role = `Вы не можете назначить роль выше вашей (ваша роль: ${currentAdminRole})`;
    }
    if (!newAdmin.firstName.trim()) newErrors.firstName = 'Имя обязательно';
    if (!newAdmin.secondName.trim()) newErrors.secondName = 'Фамилия обязательна';
    if (!newAdmin.login.trim()) newErrors.login = 'Логин обязателен';
    if (!newAdmin.password) newErrors.password = 'Пароль обязателен';
    if (newAdmin.password.length < 6) newErrors.password = 'Пароль должен быть не менее 6 символов';
    if (newAdmin.password !== newAdmin.confirmPassword) newErrors.confirmPassword = 'Пароли не совпадают';
    if (!newAdmin.mobile.trim()) newErrors.mobile = 'Телефон обязателен';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Создание нового администратора
  const handleCreateAdmin = async () => {
    setErrors({});
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      const adminToCreate = {
        ...newAdmin,
        confirmPassword: undefined // Убираем поле подтверждения пароля
      };

      API.CreateAdmin(adminData, adminToCreate).then((data) => {
        if(data.status == 200){
          API.ViewAdmins(adminData).then((_data) => {
            if(_data.status == 200){
              setAdmins(data.res.data)
            }
            resetForm();
            setIsCreateNew(false);
          }).catch(e => {console.error(e)})

        }
      }).catch(e => {console.error(e)})
    } catch (error) {
      setErrors({ submit: 'Ошибка соединения' });
      console.error('Ошибка при создании администратора:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEditInputChange = (field, value) => {
  setEditAdmin(prev => ({
    ...prev,
    [field]: value
  }));
  
  if (errors[field]) {
    setErrors(prev => ({
      ...prev,
      [field]: ''
    }));
  }
};

// Обработчик изменения прав при редактировании
const handleEditPermissionChange = (permission, value) => {
  setEditAdmin(prev => ({
    ...prev,
    [permission]: value
  }));
};

// Сохранение изменений
const handleSaveAdmin = async () => {
  setErrors({});
  if (!validateEditForm()) return;

  setIsSubmitting(true);
  try {
    API.EditAdmin(adminData, editAdmin).then((data) => {
      if(data.status == 200){
        API.ViewAdmins(adminData).then((data) => {
          if(data.status == 200){
            setAdmins(data.res.data);
          }
        }).catch(e => console.error(e))
        setIsEditing(false);
        setEditAdmin(null);
        setSelectedAdmin(editAdmin); // Обновляем выбранного админа 
        console.log('Администратор успешно обновлен');
      }
    }).catch(e => console.error(e))
    
  } catch (error) {
    setErrors({ submit: 'Ошибка соединения' });
    console.error('Ошибка при обновлении администратора:', error);
  } finally {
    setIsSubmitting(false);
  }
};

// Валидация формы редактирования
const validateEditForm = () => {
  const newErrors = {};

  if (!editAdmin.firstName.trim()) newErrors.firstName = 'Имя обязательно';
  if (!editAdmin.secondName.trim()) newErrors.secondName = 'Фамилия обязательна';
  if (!editAdmin.login.trim()) newErrors.login = 'Логин обязателен';
  if (!editAdmin.mobile.trim()) newErrors.mobile = 'Телефон обязателен';

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

// Отмена редактирования
const handleCancelEdit = () => {
  setIsEditing(false);
  setEditAdmin(null);
  setErrors({});
};

const handleOpenDeleteConfirm = (admin) => {
  setAdminToDelete(admin);
  setShowDeleteConfirm(true);
};

// Обработчик закрытия подтверждения удаления
const handleCloseDeleteConfirm = () => {
  setShowDeleteConfirm(false);
  setAdminToDelete(null);
};

// Обработчик удаления администратора
const handleDeleteAdmin = async () => {
  if (!adminToDelete) return;

  setIsSubmitting(true);
  try {
    const response = await API.DeleteAdmin(adminData, { login: adminToDelete.login });
    
    if (response.res.meta === "AdminDeleted") {
      // Обновляем список администраторов
      const updatedAdmins = await API.ViewAdmins(adminData);
      setAdmins(updatedAdmins.res.data);
      
      // Сбрасываем выбранного админа если он был удален
      if (selectedAdmin && selectedAdmin.login === adminToDelete.login) {
        setSelectedAdmin(null);
      }
      
      console.log('Администратор успешно удален');
    } else {
      // Обработка ошибок на основе meta
      let errorMessage = 'Ошибка при удалении администратора';
      switch (response.res.meta) {
        case "AdminNotExist":
          errorMessage = 'Администратор не найден';
          break;
        case "AdminIncorectPassw":
          errorMessage = 'Неверный пароль';
          break;
        case "AdminIncorectRights":
          errorMessage = 'Недостаточно прав для удаления';
          break;
        default:
          errorMessage = response.res.msg || errorMessage;
      }
      setErrors({ submit: errorMessage });
    }
  } catch (error) {
    setErrors({ submit: 'Ошибка соединения' });
    console.error('Ошибка при удалении администратора:', error);
  } finally {
    setIsSubmitting(false);
    handleCloseDeleteConfirm();
  }
};

  // Сброс формы
  const resetForm = () => {
    setNewAdmin({
      firstName: '',
      secondName: '',
      thirdName: '',
      birthDate: '',
      login: '',
      password: '',
      confirmPassword: '',
      mobile: '',
      role: adminData?.role || 4,
      canViewAdmins: false,
      canAddAdmins: false,
      canEditAdmins: false,
      canDeleteAdmins: false,
      canCreateEvent: false,
      canEditEvent: false,
      canChangeEventStatus: false,
      canDeleteMembers: false,
      canViewUsers: false,
      canDeleteUsers: false,
      canScanQR: false
    });
    setErrors({});
  };

  const handleCancel = () => {
    resetForm();
    setIsCreateNew(false);
  };

  useEffect(() => {
    if(adminData != null){
      API.ViewAdmins(adminData).then((data) => {
      setAdmins(data.res.data)
    })
    }
  }, [adminData])

  return (
    <section className='adminsSection'>
      <h2>Администраторы</h2>
      <div className="adminSetings">
        <LiquidBlock className={'topLigBlockAdm'}>
          <div className="topAdminsPanel">
              <h3 className='selAdmTxt'>Выберете Администратора</h3>
              {adminData?.canAddAdmins ? <LiquidRoundButton onClick={() => {
                setIsCreateNew(true);
                setIsEditing(false);
                setSelectedAdmin(null);
                setEditAdmin(null);
              }}>+</LiquidRoundButton> : null}
          </div>
          <LiquidSelector
              id="admin-selector"
              name="selectedAdmin"
              options={admins}
              value={selectedAdmin}
              onChange={handleAdminSelect}
              className="form-control"
              placeholder="Выберите администратора"
              getOptionLabel={formatAdminName}
              getOptionValue={getAdminId}
              required={true}
            />
        </LiquidBlock>
        
        {selectedAdmin != null && !isEditing ? (
        <LiquidBlock>
          <div className="adminFio">
            <h2>{selectedAdmin.firstName} <span className='smallerFIOAdm'>{selectedAdmin.secondName} {selectedAdmin.thirdName}</span></h2>
          </div>
          <h3 className='AdminDataBM'>{selectedAdmin?.birthDate} | {selectedAdmin?.mobile}</h3>
          <h3>Права:</h3>
          <div className="rightsBlockAdm">
            <p>Просмотр администраторов: <span className='rightStatus'>{selectedAdmin.canViewAdmins ? 'Да' : 'Нет'}</span></p>
            <p>Добавление администраторов: <span className='rightStatus'>{selectedAdmin.canAddAdmins ? 'Да' : 'Нет'}</span></p>
            <p>Изменение администраторов: <span className='rightStatus'>{selectedAdmin.canEditAdmins ? 'Да' : 'Нет'}</span></p>
            <p>Удаление администраторов: <span className='rightStatus'>{selectedAdmin.canDeleteAdmins ? 'Да' : 'Нет'}</span></p>
            <p>Создание мероприятий: <span className='rightStatus'>{selectedAdmin.canCreateEvent ? 'Да' : 'Нет'}</span></p>
            <p>Редактирование мероприятий: <span className='rightStatus'>{selectedAdmin.canEditEvent ? 'Да' : 'Нет'}</span></p>
            <p>Изменение статуса мероприятя: <span className='rightStatus'>{selectedAdmin.canChangeEventStatus ? 'Да' : 'Нет'}</span></p>
            <p>Удаление участников: <span className='rightStatus'>{selectedAdmin.canDeleteMembers ? 'Да' : 'Нет'}</span></p>
            <p>Просмотр пользователей: <span className='rightStatus'>{selectedAdmin.canViewUsers ? 'Да' : 'Нет'}</span></p>
            <p>Удаление пользователей: <span className='rightStatus'>{selectedAdmin.canDeleteUsers ? 'Да' : 'Нет'}</span></p>
            <p>Сканирование QR билетов: <span className='rightStatus'>{selectedAdmin.canScanQR ? 'Да' : 'Нет'}</span></p>
          </div>
          <div className="roleLevel">
            <div className="adminButtonsEdit">
              {adminData.canEditAdmins && adminData.role < selectedAdmin.role ? 
              <LiquidRoundButton onClick={() => {
                setIsEditing(true);
                setIsCreateNew(false);
                setEditAdmin({...selectedAdmin});
              }}>
                <img className="editAdminIcon" src={editAdminIcon} alt="Редактировать" />
              </LiquidRoundButton> : null}
              {adminData.canDeleteAdmins && adminData.role < selectedAdmin.role ? 
              <LiquidRoundButton onClick={() => handleOpenDeleteConfirm(selectedAdmin)}>
                <img className="editAdminIcon" src={deleteAdminIcon} alt="Удалить" />
              </LiquidRoundButton> : null}
            </div>
            <h1>{selectedAdmin.role}</h1>
          </div>
        </LiquidBlock>
      ) : null}

      {isEditing && editAdmin ? (
        <LiquidBlock className="edit-admin-block">
          <div className="edit-admin-header">
            <h2>Редактирование администратора</h2>
            <div className="admin-form-actions">
              <LiquidRoundButton onClick={handleSaveAdmin} disabled={isSubmitting}>
                <img className="editAdminIcon" src={saveIcon} alt="Сохранить" />
              </LiquidRoundButton>
              <LiquidRoundButton onClick={handleCancelEdit} disabled={isSubmitting}>
                <img className="editAdminIcon" src={cancelIcon} alt="Отмена" />
              </LiquidRoundButton>
            </div>
          </div>

          {errors.submit && <div className="error-message">{errors.submit}</div>}

          <div className="admin-form">
            <div className="form-section">
              <h3>Основная информация</h3>
              <div className="form-row">
                <div className="form-group">
                  <label>Имя *</label>
                  <input
                    type="text"
                    value={editAdmin.firstName}
                    onChange={(e) => handleEditInputChange('firstName', e.target.value)}
                    className={errors.firstName ? 'error' : ''}
                  />
                  {errors.firstName && <span className="field-error">{errors.firstName}</span>}
                </div>
                <div className="form-group">
                  <label>Фамилия *</label>
                  <input
                    type="text"
                    value={editAdmin.secondName}
                    onChange={(e) => handleEditInputChange('secondName', e.target.value)}
                    className={errors.secondName ? 'error' : ''}
                  />
                  {errors.secondName && <span className="field-error">{errors.secondName}</span>}
                </div>
                <div className="form-group">
                  <label>Отчество</label>
                  <input
                    type="text"
                    value={editAdmin.thirdName}
                    onChange={(e) => handleEditInputChange('thirdName', e.target.value)}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Дата рождения</label>
                  <input
                    type="date"
                    value={editAdmin.birthDate}
                    onChange={(e) => handleEditInputChange('birthDate', e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label>Телефон *</label>
                  <input
                    type="tel"
                    value={editAdmin.mobile}
                    onChange={(e) => handleEditInputChange('mobile', e.target.value)}
                    className={errors.mobile ? 'error' : ''}
                  />
                  {errors.mobile && <span className="field-error">{errors.mobile}</span>}
                </div>
              </div>
            </div>

            <div className="form-section">
              <h3>Учетные данные</h3>
              <div className="form-row">
                <div className="form-group">
                  <label>Логин *</label>
                  <input
                    type="text"
                    value={editAdmin.login}
                    onChange={(e) => handleEditInputChange('login', e.target.value)}
                    className={errors.login ? 'error' : ''}
                  />
                  {errors.login && <span className="field-error">{errors.login}</span>}
                </div>
                <div className="form-group">
                  <label>Новый пароль</label>
                  <input
                    type="password"
                    placeholder="Оставьте пустым, если не меняется"
                    onChange={(e) => handleEditInputChange('password', e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="form-section">
              <h3>Права доступа</h3>
              <div className="permissions-grid-create">
                <div className="permission-category">
                  <h4>Администраторы</h4>
                  <ToggleSwitch
                    label="Просмотр администраторов"
                    checked={editAdmin.canViewAdmins}
                    onChange={(value) => handleEditPermissionChange('canViewAdmins', value)}
                  />
                  <ToggleSwitch
                    label="Добавление администраторов"
                    checked={editAdmin.canAddAdmins}
                    onChange={(value) => handleEditPermissionChange('canAddAdmins', value)}
                  />
                  <ToggleSwitch
                    label="Редактирование администраторов"
                    checked={editAdmin.canEditAdmins}
                    onChange={(value) => handleEditPermissionChange('canEditAdmins', value)}
                  />
                  <ToggleSwitch
                    label="Удаление администраторов"
                    checked={editAdmin.canDeleteAdmins}
                    onChange={(value) => handleEditPermissionChange('canDeleteAdmins', value)}
                  />
                </div>

                <div className="permission-category">
                  <h4>Мероприятия</h4>
                  <ToggleSwitch
                    label="Создание мероприятий"
                    checked={editAdmin.canCreateEvent}
                    onChange={(value) => handleEditPermissionChange('canCreateEvent', value)}
                  />
                  <ToggleSwitch
                    label="Редактирование мероприятий"
                    checked={editAdmin.canEditEvent}
                    onChange={(value) => handleEditPermissionChange('canEditEvent', value)}
                  />
                  <ToggleSwitch
                    label="Изменение статуса мероприятий"
                    checked={editAdmin.canChangeEventStatus}
                    onChange={(value) => handleEditPermissionChange('canChangeEventStatus', value)}
                  />
                </div>

                <div className="permission-category">
                  <h4>Пользователи</h4>
                  <ToggleSwitch
                    label="Просмотр пользователей"
                    checked={editAdmin.canViewUsers}
                    onChange={(value) => handleEditPermissionChange('canViewUsers', value)}
                  />
                  <ToggleSwitch
                    label="Удаление пользователей"
                    checked={editAdmin.canDeleteUsers}
                    onChange={(value) => handleEditPermissionChange('canDeleteUsers', value)}
                  />
                  <ToggleSwitch
                    label="Удаление участников"
                    checked={editAdmin.canDeleteMembers}
                    onChange={(value) => handleEditPermissionChange('canDeleteMembers', value)}
                  />
                </div>

                <div className="permission-category">
                  <h4>Другие права</h4>
                  <ToggleSwitch
                    label="Сканирование QR-кодов"
                    checked={editAdmin.canScanQR}
                    onChange={(value) => handleEditPermissionChange('canScanQR', value)}
                  />
                  <div className="form-group">
                    <label>Уровень роли</label>
                    <LiquidSelector
                      options={getAvailableRoles()}
                      value={getAvailableRoles().find(role => role.value === editAdmin.role)}
                      onChange={(selectedRole) => handleEditInputChange('role', selectedRole?.value || adminData?.role || 4)}
                      placeholder="Выберите уровень роли"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      className="role-selector"
                    />
                    <div className="role-hint">
                      Текущий администратор имеет уровень {adminData?.role || 4}. 
                      Вы можете назначать роли от {adminData?.role || 4} до 4.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LiquidBlock>
      ) : null}
        
        {isCreateNew ? (
          <LiquidBlock className="create-admin-block">
            <div className="create-admin-header">
              <h2>Создание нового администратора</h2>
              <div className="admin-form-actions">
                <LiquidRoundButton onClick={handleCreateAdmin} disabled={isSubmitting}>
                  <img className="editAdminIcon" src={saveIcon} alt="Сохранить" />
                </LiquidRoundButton>
                <LiquidRoundButton onClick={handleCancel} disabled={isSubmitting}>
                  <img className="editAdminIcon" src={cancelIcon} alt="Отмена" />
                </LiquidRoundButton>
              </div>
            </div>

            {errors.submit && <div className="error-message">{errors.submit}</div>}

            <div className="admin-form">
              <div className="form-section">
                <h3>Основная информация</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>Фамилия *</label>
                    <input
                      type="text"
                      value={newAdmin.firstName}
                      onChange={(e) => handleInputChange('firstName', e.target.value)}
                      className={errors.firstName ? 'error' : ''}
                    />
                    {errors.secondName && <span className="field-error">{errors.secondName}</span>}
                  </div>
                  <div className="form-group">
                    <label>Имя *</label>
                    <input
                      type="text"
                      value={newAdmin.secondName}
                      onChange={(e) => handleInputChange('secondName', e.target.value)}
                      className={errors.secondName ? 'error' : ''}
                    />
                    {errors.firstName && <span className="field-error">{errors.firstName}</span>}
                  </div>
                  <div className="form-group">
                    <label>Отчество</label>
                    <input
                      type="text"
                      value={newAdmin.thirdName}
                      onChange={(e) => handleInputChange('thirdName', e.target.value)}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Дата рождения</label>
                    <input
                      type="date"
                      value={newAdmin.birthDate}
                      onChange={(e) => handleInputChange('birthDate', e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Телефон *</label>
                    <input
                      type="tel"
                      value={newAdmin.mobile}
                      onChange={(e) => handleInputChange('mobile', e.target.value)}
                      className={errors.mobile ? 'error' : ''}
                    />
                    {errors.mobile && <span className="field-error">{errors.mobile}</span>}
                  </div>
                </div>
              </div>

              <div className="form-section">
                <h3>Учетные данные</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>Логин *</label>
                    <input
                      type="text"
                      value={newAdmin.login}
                      onChange={(e) => handleInputChange('login', e.target.value)}
                      className={errors.login ? 'error' : ''}
                    />
                    {errors.login && <span className="field-error">{errors.login}</span>}
                  </div>
                  <div className="form-group">
                    <label>Пароль *</label>
                    <input
                      type="password"
                      value={newAdmin.password}
                      onChange={(e) => handleInputChange('password', e.target.value)}
                      className={errors.password ? 'error' : ''}
                    />
                    {errors.password && <span className="field-error">{errors.password}</span>}
                  </div>
                  <div className="form-group">
                    <label>Подтверждение пароля *</label>
                    <input
                      type="password"
                      value={newAdmin.confirmPassword}
                      onChange={(e) => handleInputChange('confirmPassword', e.target.value)}
                      className={errors.confirmPassword ? 'error' : ''}
                    />
                    {errors.confirmPassword && <span className="field-error">{errors.confirmPassword}</span>}
                  </div>
                </div>
              </div>

              <div className="form-section">
                <h3>Права доступа</h3>
                <div className="permissions-grid-create">
                  <div className="permission-category">
                    <h4>Администраторы</h4>
                    <ToggleSwitch
                      label="Просмотр администраторов"
                      checked={newAdmin.canViewAdmins}
                      onChange={(value) => handlePermissionChange('canViewAdmins', value)}
                    />
                    <ToggleSwitch
                      label="Добавление администраторов"
                      checked={newAdmin.canAddAdmins}
                      onChange={(value) => handlePermissionChange('canAddAdmins', value)}
                    />
                    <ToggleSwitch
                      label="Редактирование администраторов"
                      checked={newAdmin.canEditAdmins}
                      onChange={(value) => handlePermissionChange('canEditAdmins', value)}
                    />
                    <ToggleSwitch
                      label="Удаление администраторов"
                      checked={newAdmin.canDeleteAdmins}
                      onChange={(value) => handlePermissionChange('canDeleteAdmins', value)}
                    />
                  </div>

                  <div className="permission-category">
                    <h4>Мероприятия</h4>
                    <ToggleSwitch
                      label="Создание мероприятий"
                      checked={newAdmin.canCreateEvent}
                      onChange={(value) => handlePermissionChange('canCreateEvent', value)}
                    />
                    <ToggleSwitch
                      label="Редактирование мероприятий"
                      checked={newAdmin.canEditEvent}
                      onChange={(value) => handlePermissionChange('canEditEvent', value)}
                    />
                    <ToggleSwitch
                      label="Изменение статуса мероприятий"
                      checked={newAdmin.canChangeEventStatus}
                      onChange={(value) => handlePermissionChange('canChangeEventStatus', value)}
                    />
                  </div>

                  <div className="permission-category">
                    <h4>Пользователи</h4>
                    <ToggleSwitch
                      label="Просмотр пользователей"
                      checked={newAdmin.canViewUsers}
                      onChange={(value) => handlePermissionChange('canViewUsers', value)}
                    />
                    <ToggleSwitch
                      label="Удаление пользователей"
                      checked={newAdmin.canDeleteUsers}
                      onChange={(value) => handlePermissionChange('canDeleteUsers', value)}
                    />
                    <ToggleSwitch
                      label="Удаление участников"
                      checked={newAdmin.canDeleteMembers}
                      onChange={(value) => handlePermissionChange('canDeleteMembers', value)}
                    />
                  </div>

                  <div className="permission-category">
                    <h4>Другие права</h4>
                    <ToggleSwitch
                      label="Сканирование QR-кодов"
                      checked={newAdmin.canScanQR}
                      onChange={(value) => handlePermissionChange('canScanQR', value)}
                    />
                    <div className="form-group">
                      <label>Уровень роли</label>
                      <LiquidSelector
                        options={getAvailableRoles()}
                        value={getAvailableRoles().find(role => role.value === newAdmin.role)}
                        onChange={(selectedRole) => handleInputChange('role', selectedRole?.value || adminData?.role || 4)}
                        placeholder="Выберите уровень роли"
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        className="role-selector"
                      />
                      <div className="role-hint">
                        Текущий администратор имеет уровень {adminData?.role || 4}. 
                        Вы можете назначать роли от {adminData?.role || 4} до 4.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LiquidBlock>
        ) : null}
      </div>
      {showDeleteConfirm && adminToDelete && (
        <div className="modal-overlay">
          <LiquidBlock className="delete-confirm-modal">
            <div className="delete-confirm-header">
              <h3>Подтверждение удаления</h3>
            </div>
            
            <div className="delete-confirm-content">
              <p>Вы уверены, что хотите удалить администратора:</p>
              <p className="admin-to-delete-name">
                {adminToDelete.firstName} {adminToDelete.secondName} {adminToDelete.thirdName}
              </p>
              <p className="delete-warning">
                Это действие нельзя отменить!
              </p>
            </div>

            {errors.submit && <div className="error-message">{errors.submit}</div>}

            <div className="delete-confirm-actions">
              <LiquidButton 
                onClick={handleDeleteAdmin} 
                disabled={isSubmitting}
                className="delete-btn"
              >
                {isSubmitting ? 'Удаление...' : 'Удалить'}
              </LiquidButton>
              <LiquidButton 
                onClick={handleCloseDeleteConfirm} 
                disabled={isSubmitting}
                className="cancel-btn"
              >
                Отмена
              </LiquidButton>
            </div>
          </LiquidBlock>
        </div>
      )}
    </section>
  )
}

export default Admins